import { Button } from "react-admin";

export const MyIconButton = ({ sx, ...props }) => {
  return (
    <Button
      sx={{
        padding: "8px",
        minWidth: "0",
        "& .MuiButton-startIcon": {
          margin: "0",
        },
        ...sx,
      }}
      {...props}
    />
  );
};
